import type { PaperFontSize } from '../../../utils/paperFontSize';

const OPTIONS: { value: PaperFontSize; label: string }[] = [
  { value: 'small', label: '小' },
  { value: 'medium', label: '中' },
  { value: 'large', label: '大' },
];

/**
 * 试卷字号三档选择控件（小/中/大，默认小）
 * 样式对齐答题卡现有控件（圆角分段按钮、蓝/灰主题）
 */
export default function FontSizeSelector({
  value,
  onChange,
}: {
  value: PaperFontSize;
  onChange: (size: PaperFontSize) => void;
}) {
  return (
    <div className="flex items-center justify-between gap-2 mb-3">
      <span className="text-xs text-gray-500 shrink-0">试卷字号</span>
      <div className="flex items-center gap-1 bg-gray-100 rounded-lg p-0.5">
        {OPTIONS.map(opt => (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={`px-2.5 py-0.5 text-xs font-medium rounded-md transition-colors ${
              value === opt.value
                ? 'bg-blue-500 text-white shadow-sm'
                : 'text-gray-600 hover:bg-gray-200'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
